import React from 'react';
import { Panel, useKeyPress, useReactFlow, useViewport } from '@xyflow/react';
import { useShallow } from 'zustand/react/shallow';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { AppState, useCanvasStore } from '../store';
import { isMetricNode, isPureTextNode, isStickyNoteNode, isTextNode } from '../nodes/types';
import { MAX_ZOOM, MIN_ZOOM } from '../constants';
import { MetricNodeType } from '../nodes/metric-node/types';
import styles from './index.module.styl';
import { FilterPanel } from './filter-panel';
import { QueryBuilderPanel } from './qb-panel';
const selector = (state: AppState) => {
  var _state$getNode, _state$canvas;
  const currentActiveNode = state.activeMetricNodeId ? (_state$getNode = state.getNode<MetricNodeType>(state.activeMetricNodeId)) !== null && _state$getNode !== void 0 ? _state$getNode : null : null;
  return {
    isViewOnly: !((_state$canvas = state.canvas) !== null && _state$canvas !== void 0 && _state$canvas.can_update_basic),
    currentActiveNode,
    stageGhostNode: state.stageGhostNode,
    showQBPanel: currentActiveNode ? isMetricNode(currentActiveNode) : false,
    hasGhostNode: Boolean(state.ghostNode),
    hasMetricGhostNode: state.ghostNode ? isMetricNode(state.ghostNode) : false,
    hasTextGhostNode: state.ghostNode ? isTextNode(state.ghostNode) : false,
    hasPureTextGhostNode: state.ghostNode ? isPureTextNode(state.ghostNode) : false,
    hasStickyNoteGhostNode: state.ghostNode ? isStickyNoteNode(state.ghostNode) : false
  };
};
export function PanelControls() {
  const {
    isViewOnly,
    currentActiveNode,
    stageGhostNode,
    hasGhostNode,
    hasMetricGhostNode,
    hasTextGhostNode,
    hasPureTextGhostNode,
    hasStickyNoteGhostNode,
    showQBPanel
  } = useCanvasStore(useShallow(selector));
  const isShiftPressed = useKeyPress("Shift");
  const {
    zoomTo
  } = useReactFlow();
  const {
    zoom
  } = useViewport();
  return <>
      <Panel position='top-left' style={{
      top: 16
    }} data-sentry-element="Panel" data-sentry-source-file="index.tsx">
        <FilterPanel data-sentry-element="FilterPanel" data-sentry-source-file="index.tsx" />
      </Panel>
      <Panel position='top-right' style={{
      top: 16,
      right: showQBPanel ? 300 : 0
    }} data-sentry-element="Panel" data-sentry-source-file="index.tsx">
        <div className={styles.zoomPanel}>
          <ButtonReact disabled={zoom >= MAX_ZOOM} icon={"plus"} theme={ButtonTheme.Tertiary} onClick={_ => zoomTo(zoom * 2, {
          duration: 500
        })} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx" />
          <ButtonReact disabled={zoom <= MIN_ZOOM} icon={"dash"} theme={ButtonTheme.Tertiary} onClick={_ => zoomTo(zoom / 2, {
          duration: 500
        })} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx" />
        </div>
      </Panel>
      <Panel position='top-right' data-sentry-element="Panel" data-sentry-source-file="index.tsx">{showQBPanel && <QueryBuilderPanel activeMetricNode={currentActiveNode!} />}</Panel>
      {!isViewOnly && <Panel position='bottom-center'>
          <div className={styles.toolBarPanel}>
            <ButtonReact pressed={!hasGhostNode} className={styles.toolBarIcon} icon={isShiftPressed ? "cursor-outlined" : "drag-hand"} theme={ButtonTheme.Tertiary} />
            <ButtonReact pressed={hasMetricGhostNode} className={styles.toolBarIcon} icon={"cube-outlined"} theme={ButtonTheme.Tertiary} onClick={() => stageGhostNode("metric")} />
            <ButtonReact pressed={hasTextGhostNode} className={styles.toolBarIcon} icon={"cube-dotted"} theme={ButtonTheme.Tertiary} onClick={() => stageGhostNode("text")} />
            <ButtonReact pressed={hasPureTextGhostNode} className={styles.toolBarIcon} icon={"pure-text-node"} theme={ButtonTheme.Tertiary} onClick={() => stageGhostNode("pureText")} />
            <ButtonReact pressed={hasStickyNoteGhostNode} className={styles.toolBarIcon} icon={"sticky-note"} theme={ButtonTheme.Tertiary} onClick={() => stageGhostNode("stickyNote")} />
          </div>
        </Panel>}
    </>;
}